import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
    .ant-modal-content {
        padding: 16px;
        border-radius: 6px;
        min-height: 236px;
        .ant-modal-header {
            border-bottom: 0;
        }
        .ant-modal-footer {
            border-top: 0;
        }
    }

    .ant-modal-header {
        padding: 24px 16px;
        padding-bottom: 8px;
    }

    .ant-modal-body {
        padding: 24px 16px;
        padding-top: 8px;
    }
`;
